import type {SystemProps} from '@chakra-ui/styled-system';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {tokens} from '../../../generated/light';
import {headingTheme} from '../../Heading/theme';
import {textTheme} from '../../Text/theme';

import {widgetAnatomy} from './anatomy';
import {vars} from './css-vars';

const {widgets} = tokens.components;

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(widgetAnatomy.keys());

const bodyLayout = {
  display: `flex`,
  justifyContent: `space-between`,
  alignItems: `center`,
  alignSelf: `stretch`,
  flexGrow: 1,
} satisfies SystemProps;
const baseStyle = definePartsStyle(() => ({
  container: {
    [vars.background.variable]: `colors.background.primary`,
    // TODO: ask design why the radius is in the space token
    [vars.radius.variable]: `space.${widgets.radius}`,
    [vars[`border-color`].variable]: `colors.stroke.primary`,
    [vars.shadow.variable]: `shadows.xs`,
    [vars[`padding-horizontal`].variable]: `space.${widgets[`side-padding`]}`,
    [vars[`padding-vertical`].variable]: `space.${widgets[`top-bottom-padding`]}`,
    [vars.gap.variable]: `space.space-200`,

    bgColor: vars.background.reference,
    borderRadius: vars.radius.reference,
    boxShadow: vars.shadow.reference,

    border: `1px solid`,
    [`&&`]: {
      borderColor: vars[`border-color`].reference,
    },
    [`&[data-interactive]`]: {
      transition: `box-shadow ease-in-out 0.4s`,
      cursor: `pointer`,
      _hover: {
        boxShadow: `xl`,
      },
    },

    px: vars[`padding-horizontal`].reference,
    py: vars[`padding-vertical`].reference,

    display: `flex`,
    flexDirection: `column`,
    gap: vars.gap.reference,
    alignItems: `stretch`,

    overflow: `hidden`,
  },
  header: {
    display: `flex`,
    justifyContent: `space-between`,
    alignItems: `center`,
    alignSelf: `stretch`,
  } satisfies SystemProps,
  title: {
    overflow: `hidden`,
    whiteSpace: `nowrap`,
    textOverflow: `ellipsis`,
    alignSelf: `flex-start`,
    ...headingTheme.baseStyle,
    ...headingTheme.sizes?.sm,
  } satisfies SystemProps,
  icon: {
    borderRadius: `full`,
    size: `36`,
    border: `base`,
    borderColor: ``,
    background: `background.overlay`,
  },
  body: bodyLayout,
  skeleton: {
    flex: 1,
    alignSelf: `stretch`,
    justifySelf: `stretch`,
  },
  footer: {},
  empty: {...bodyLayout, ...textTheme.baseStyle?.(), ...textTheme.sizes?.lg, gap: `space-200`},
  error: {...bodyLayout, ...textTheme.baseStyle?.(), ...textTheme.sizes?.lg, gap: `space-200`, alignItems: `center`},
}));

export const widgetTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {},
  sizes: {},
  defaultProps: {},
});
